import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MdmActivity, TopicListItem } from "./models";
import storage from "redux-persist/lib/storage";

const initialState: MdmActivity = {
  selectedUnit: "",
  topicList: [],
  activityFramework: "",
};

const mdmActivitySlice = createSlice({
  name: "mdmActivitySlice",
  initialState,
  reducers: {
    updateSelectedUnit: (state, action: PayloadAction<string>) => {
      state.selectedUnit = action.payload;
    },
    addNewTopicToList: (state, { payload }: PayloadAction<TopicListItem>) => {
      state.topicList.push(payload);
    },
    setActivityTopicList: (
      state,
      { payload }: PayloadAction<TopicListItem[]>,
    ) => {
      state.topicList = payload;
    },
    clearMdmActivityState: (state) => {
      state.topicList = [];
    },
    updateTopicInList: (state, { payload }: PayloadAction<TopicListItem>) => {
      const index = state.topicList.findIndex((item) => item.id === payload.id);
      if (index !== -1) {
        state.topicList[index] = payload;
      }
    },
    setActivityFramework: (state, { payload }: PayloadAction<string>) => {
      state.activityFramework = payload;
    },
  },
});

export const {
  updateSelectedUnit,
  addNewTopicToList,
  clearMdmActivityState,
  setActivityTopicList,
  updateTopicInList,
  setActivityFramework,
} = mdmActivitySlice.actions;

export const persistMdmActivityConfig = {
  version: 1,
  key: "mpg_next_admin_program_v1",
  storage,
  whitelist: [],
};

export default mdmActivitySlice.reducer;
